<template>
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 494.881 494.881"
    style="enable-background: new 0 0 494.881 494.881"
    xml:space="preserve"
  >
    <g id="XMLID_211_">
      <path
        id="XMLID_216_"
        d="M196.782,63.877c-0.067,0.913-0.276,1.787-0.276,2.719c0,25.56,20.716,46.269,46.273,46.269
		c25.588,0,46.286-20.71,46.286-46.269c0-0.932-0.222-1.806-0.27-2.719H197.09H196.782z"
      />
      <path
        id="XMLID_215_"
        d="M366.799,278.201l-65.993-144.592c-3.881-8.501-11.933-11.822-21.559-11.822h-71.872
		c-8.525,0-16.177,1.996-20.882,8.759l-9.122,13.156l9.835-3.751l32.864-12.561c13.845-5.289,29.272,1.756,34.481,15.43
		l26.135,68.445c5.228,13.692-1.55,29.193-15.427,34.482l-25.329,9.664c-6.175,10.232-17.32,16.693-29.438,16.693
		c-5.849,0-24.418-4.521-30.76-5.904l-8.23,146.896c-0.179,2.992,0.886,5.912,2.958,8.087c2.036,2.175,4.915,3.404,7.892,3.404
		h4.269v46.541c0,13.116,10.647,23.751,23.761,23.751c13.12,0,23.761-10.635,23.761-23.751v-46.541h17.302v46.541
		c0,13.116,10.641,23.751,23.761,23.751c13.119,0,23.76-10.635,23.76-23.751v-46.541h4.299c2.996,0,5.837-1.229,7.892-3.388
		c2.054-2.167,3.137-5.08,2.977-8.057l-9.153-175.039l25.815,56.528c4.54,9.989,16.3,14.306,26.215,9.794
		C366.959,299.883,371.344,288.142,366.799,278.201z"
      />
      <path
        id="XMLID_214_"
        d="M179.314,195.475l38.474,8.408c15.802,3.444,26.609,17.25,27.027,32.719l14.787-5.642
		c5.561-2.12,8.439-8.377,6.286-14.049l-26.135-68.439c-2.153-5.637-8.458-8.41-14.055-6.282l-48.069,18.366
		c-5.628,2.142-8.439,8.433-6.292,14.046L179.314,195.475z"
      />
      <path
        id="XMLID_213_"
        d="M209.361,257.308c9.109,0,17.309-6.317,19.314-15.569c2.344-10.685-4.435-21.227-15.107-23.564
		l-41.26-9.016l-5.16-1.132l-10.611-27.771c-0.578-1.554-0.965-3.131-1.261-4.706l-25.452,36.666c0,0.016-0.019,0.031-0.037,0.056
		l-0.062,0.105c-3.801,5.452-4.336,13.012-2.171,18.52c2.141,5.395,7.603,10.65,14.203,12.094
		C145.072,243.719,206.095,257.308,209.361,257.308z"
      />
      <path
        id="XMLID_212_"
        d="M182.869,16.56h14.221v33.092h91.974V16.56h7.553v41.808c0,4.287,3.672,8.283,8.285,8.283
		c4.576,0,8.28-3.703,8.28-8.283V8.279c0-4.602-3.027-8.279-9.897-8.279H182.869c-6.858,0-9.897,3.678-9.897,8.279
		C172.972,12.883,176.011,16.56,182.869,16.56z"
      />
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>